"use strict";

var e = require("react/jsx-runtime"),
    s = require("react"),
    _a = function a() {
  return (_a = Object.assign || function (e) {
    for (var s, a = 1, i = arguments.length; a < i; a++) {
      for (var t in s = arguments[a]) {
        Object.prototype.hasOwnProperty.call(s, t) && (e[t] = s[t]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function i() {
  return e.jsx("svg", _a({
    focusable: "false",
    viewBox: "0 0 448 512",
    "aria-hidden": "true"
  }, {
    children: e.jsx("path", {
      d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    }, void 0)
  }), void 0);
}

function t() {
  return e.jsx("svg", _a({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "45",
    height: "45"
  }, {
    children: e.jsx("path", {
      d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    }, void 0)
  }), void 0);
}

function o() {
  return e.jsx("svg", _a({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, {
    children: e.jsx("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }, void 0)
  }), void 0);
}

function d() {
  return e.jsx("svg", _a({
    focusable: "false",
    viewBox: "0 0 24 24",
    width: "35",
    height: "35"
  }, {
    children: e.jsx("path", {
      d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
    }, void 0)
  }), void 0);
}

var n = new Date().toTimeString().split(":").slice(0, 2).join(":");

module.exports = function (c) {
  var l,
      r = c.phoneNumber,
      v = void 0 === r ? "1234567890" : r,
      h = c.accountName,
      u = void 0 === h ? "Account Name" : h,
      p = c.avatar,
      x = void 0 === p ? "" : p,
      m = c.statusMessage,
      j = void 0 === m ? "Typically replies within 1 hour" : m,
      f = c.chatMessage,
      N = void 0 === f ? "Hello there! 🤝 \nHow can we help?" : f,
      g = c.darkMode,
      w = void 0 !== g && g,
      b = c.styles,
      y = c.className,
      B = void 0 === y ? "" : y,
      F = s.useState(!1),
      M = F[0],
      z = F[1],
      H = s.useState(""),
      S = H[0],
      C = H[1],
      D = function D() {
    return z(function (e) {
      return !e;
    });
  };

  return e.jsxs("div", _a({
    className: "floatingWhatsapp " + (w ? "dark " : "") + B
  }, {
    children: [e.jsx("div", _a({
      className: "whatsappButton",
      onClick: D,
      style: b
    }, {
      children: e.jsx(i, {}, void 0)
    }), void 0), e.jsxs("div", _a({
      className: "whatsappChatBox " + (M ? "open" : "close")
    }, {
      children: [e.jsxs("header", _a({
        className: "chatHeader"
      }, {
        children: [e.jsx("div", _a({
          className: "avatar"
        }, {
          children: x ? e.jsx("img", {
            src: x,
            width: "45",
            height: "45",
            alt: "whatsapp-avatar"
          }, void 0) : e.jsx(t, {}, void 0)
        }), void 0), e.jsxs("div", _a({
          className: "status"
        }, {
          children: [e.jsx("span", _a({
            className: "statusTitle"
          }, {
            children: u
          }), void 0), e.jsx("span", _a({
            className: "statusSubtitle"
          }, {
            children: j
          }), void 0)]
        }), void 0), e.jsx("div", _a({
          className: "close",
          onClick: D
        }, {
          children: e.jsx(o, {}, void 0)
        }), void 0)]
      }), void 0), e.jsx("div", _a({
        className: "chatBody"
      }, {
        children: e.jsxs("div", _a({
          className: "message"
        }, {
          children: [e.jsx("span", {
            className: "triangle"
          }, void 0), e.jsx("span", _a({
            className: "accountName"
          }, {
            children: u
          }), void 0), e.jsx("p", _a({
            className: "messageBody"
          }, {
            children: N
          }), void 0), e.jsx("span", _a({
            className: "messageTime"
          }, {
            children: n
          }), void 0)]
        }), void 0)
      }), void 0), e.jsx("footer", _a({
        className: "chatFooter"
      }, {
        children: e.jsxs("form", _a({
          onSubmit: function onSubmit(e) {
            e.preventDefault(), S && (window.open("https://api.whatsapp.com/send/?phone=" + v + "&text=" + S), C(""));
          }
        }, {
          children: [e.jsx("input", {
            className: "input " + (l = S, /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(l) ? "arabic" : ""),
            placeholder: "",
            autoFocus: false,
            onChange: function onChange(e) {
              return C(e.target.value);
            },
            value: S,
            dir: "auto"
          }, void 0), e.jsx("button", _a({
            type: "submit",
            className: "buttonSend",
            disabled: "" === S
          }, {
            children: e.jsx(d, {}, void 0)
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
};